module.exports = __webpack_public_path__ + "static/img/googlePlay.372ec6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/googlePlay.svg
// module id = zPl8
// module chunks = 1